import cookie from "./cookie";
import config from '../config/config';
import serviceUrl from './serviceUrl';
import queryString from 'query-string';
import languageMeta from './languageMeta';
import { resolveChannelKey } from './channel';

// 语言元数据来自 languageMeta.js
const _meta = languageMeta;
const DEFAULT_KEY = Object.keys(_meta)[0];
const DEFAULT_SUPPORTED_LANGUAGE_KEYS = ["zh_CN", "zh_TW", "en_US"];

function buildLanguageConfig(key) {
    const meta = _meta[key];
    if (!meta) return null;
    return {
        key: key,
        label: meta.label,
        _lang: meta.lang,
        geetest: meta.geetest,
        locale: key,
    };
}

function getFirstEnglishKey() {
    var keys = Object.keys(_meta);
    for (var i = 0; i < keys.length; i++) {
        if (_meta[keys[i]].lang === 'EN') return keys[i];
    }
    return DEFAULT_KEY;
}

function getFirstEnglishLang() {
    return _meta[getFirstEnglishKey()].lang;
}

function normalizeLanguageList(raw) {
    if (!raw) return null;
    if (Array.isArray(raw)) return raw;
    // ExtendedDefinePlugin 将数组序列化为 Object({"0":"zh_CN",...})
    if (typeof raw === 'object') return Object.values(raw);
    // 向后兼容旧的字符串格式
    return [raw];
}

/**
 * 从渠道配置获取支持的语言 key 数组
 * 渠道配置是真理源：数组第一位是默认语言，整个数组是该渠道支持的语言列表。
 * 语言优先级：背靠渠道channelkey语言 > 渠道语言 > 默认语言
 * channelkey优先级：cookie.channel_key > URL路径前缀（首次访问时 cookie 未设置，用路径兜底）
 */
function getSupportedLanguageKeys() {
    // 首次访问时 cookie 未设置，用 URL 路径兜底
    const channelKey = cookie.getCookie('channel_key') || resolveChannelKey() || '';
    const channelKeyLangsMap = APP_CONFIG.channelKeyLanguages;
    return normalizeLanguageList(channelKey && channelKeyLangsMap ? channelKeyLangsMap[channelKey] : null)
        || normalizeLanguageList(APP_CONFIG.languages)
        || DEFAULT_SUPPORTED_LANGUAGE_KEYS;
}

function getLanguages() {
    return getSupportedLanguageKeys()
        .map(k => buildLanguageConfig(k))
        .filter(Boolean);
}

function getDefaultLanguage() {
    return getLanguages()[0] || buildLanguageConfig(DEFAULT_KEY);
}

function getLanguageConfig(key) {
    return buildLanguageConfig(key);
}

function isEnglishLikeLanguage(key) {
    var cfg = getLanguageConfig(key);
    return cfg ? cfg._lang === getFirstEnglishLang() : false;
}

function isSupportedLanguage(key) {
    return getSupportedLanguageKeys().includes(key);
}

/**
 * 根据语言 key 获取对应的 locale 标识（用于 JSON 文件加载）
 * 每个语言 key 对应独立 JSON 文件，如 locale 为 'xx_YY' 时加载 xx_YY.json
 */
function getLocaleKey(key) {
    // 繁体中文复用简体中文语言包，加载后由 App 中的 Traditionalized 转换为繁体
    if (key === "zh_TW") return "zh_CN";
    const cfg = getLanguageConfig(key);
    return cfg ? cfg.locale : DEFAULT_KEY;
}

function setDefaultLanguageCookies(supportedKeys) {
    const defaultCfg = getLanguageConfig(supportedKeys[0]) || getDefaultLanguage();
    cookie.setCookie('_lang', defaultCfg._lang);
    cookie.setCookie('CN_lang', defaultCfg.key);
    cookie.setCookie('U_LANG', defaultCfg.key);
}

function setLanguageCookies(key) {
    const cfg = getLanguageConfig(key) || getDefaultLanguage();
    cookie.setCookie('_lang', cfg._lang);
    cookie.setCookie('CN_lang', cfg.key);
    cookie.setCookie('U_LANG', cfg.key);
}

// --- 初始化 cookie ---

const query = queryString.parse(document.location.search);
const service = serviceUrl(query['service']) || config.default;
const urlLang = query['lang'] ? decodeURIComponent(query['lang']) : '';
const firstEnKey = getFirstEnglishKey();
const firstEnLang = getFirstEnglishLang();

if (urlLang === firstEnLang || service.indexOf('lang=' + firstEnLang) > -1) {
    // url 参数的优先级最高
    cookie.setCookie('_lang', firstEnLang);
    cookie.setCookie('CN_lang', firstEnKey);
    cookie.setCookie('U_LANG', firstEnKey);
    var href = window.location.href;
    href = href.replace(new RegExp('lang=' + firstEnLang, 'g'), '');
    href = href.replace(new RegExp('lang%3D' + firstEnLang, 'g'), '');
    window.location.href = href;
} else {
    const _lang = cookie.getCookie('_lang');
    const CN_lang = cookie.getCookie('CN_lang');
    const U_LANG = cookie.getCookie('U_LANG');
    const supportedKeys = getSupportedLanguageKeys();

    if (!_lang) {
        setDefaultLanguageCookies(supportedKeys);
    } else if (isSupportedLanguage(_lang)) {
        setLanguageCookies(_lang);
    } else if (!U_LANG || CN_lang !== U_LANG || !supportedKeys.includes(CN_lang)) {
        if (U_LANG && supportedKeys.includes(U_LANG)) {
            setLanguageCookies(U_LANG);
        } else {
            setDefaultLanguageCookies(supportedKeys);
        }
    }
}

function setLang(lang, CN_lang) {
    cookie.setCookie('_lang', lang);
    cookie.setCookie('CN_lang', CN_lang);
    cookie.setCookie('U_LANG', CN_lang);
    window.location.reload();
}

function getLang(type) {
    if (type === 'CN_lang') {
        return cookie.getCookie('CN_lang');
    }

    const rawLang = cookie.getCookie('_lang');
    const cfg = getLanguageConfig(rawLang);
    return cfg ? cfg._lang : rawLang;
}

module.exports = {
    setLang,
    getLang,
    getLanguages,
    getDefaultLanguage,
    getLanguageConfig,
    isEnglishLikeLanguage,
    isSupportedLanguage,
    getLocaleKey,
    getSupportedLanguageKeys,
};



// WEBPACK FOOTER //
// ./src/common/lang.js